// Copyright (c) 2017 Deere & Company
/* eslint-disable no-process-env */
/* eslint complexity: ["error", 7] */

import {
    Component,
    PropTypes
} from 'react';
import {
    environmentIsProd,
    environmentIsReady
} from '../shared/services/environment';

class DataDog extends Component {

    componentWillMount = () => {

        this.setState({

            initComplete: false

        });

    };

    componentDidUpdate() {

        if (!this.state.initComplete && environmentIsReady(this.props.appConfig)) {

            const isProd = environmentIsProd(this.props.appConfig);

            this.addScript(isProd);
            this.markComplete();

        }

    }

    markComplete = () => {

        this.setState({

            initComplete: true

        });

    };

    addScript = isProd => {

        const datadogClientToken = process.env.DD_CLIENT_TOKEN || '';
        const datadogApplicationId = process.env.DD_APPLICATION_ID || '';
        const datadogEnv = process.env.DEPLOYMENT_ENV || '';
        const appVersion = process.env.APP_VERSION || '';

        const scriptDD = document.createElement('script');

        scriptDD.text = `
            (function(h,o,u,n,d) {
                h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
                d=o.createElement(u);d.async=1;d.src=n
                n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
            })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
            window.DD_RUM.onReady(function() {
                window.DD_RUM.init({
                    clientToken: '${datadogClientToken}',
                    applicationId: '${datadogApplicationId}',
                    site: 'datadoghq.com',
                    service: 'warranty-ui-core',
                    env: '${datadogEnv}',
                    version: '${appVersion}',
                    sessionSampleRate: ${isProd ? 100 : 100},
                    sessionReplaySampleRate: ${isProd ? 100 : 100},
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    defaultPrivacyLevel: 'allow'
                });
            })
        `;

        document.head.appendChild(scriptDD);

    };

    render = () => null;
}

DataDog.displayName = 'DataDog';
DataDog.propTypes = {

    appConfig: PropTypes.object.isRequired

};

export default DataDog;



// WEBPACK FOOTER //
// ./src/app/datadog.js